import { render, staticRenderFns } from "./DividedTitle.vue?vue&type=template&id=58b42b93&scoped=true&"
import script from "./DividedTitle.vue?vue&type=script&lang=ts&"
export * from "./DividedTitle.vue?vue&type=script&lang=ts&"
import style0 from "./DividedTitle.vue?vue&type=style&index=0&id=58b42b93&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b42b93",
  null
  
)

export default component.exports